import { useWalletModal } from './WalletModalContext';
import './../styles/Hero.css';

export default function Hero() {
  const { open } = useWalletModal();

  return (
    <section className="hero">
      <div className="hero__content">
        <h1>ZILLIQA RESOLVE</h1>
        <p>
          Having trouble with your $ZIL tokens, Migration, Staking, Bridging or Wallet Issues? Our support portal helps you diagnose and fix every issue fast.
        </p>
        <div className="hero__actions">
          <button type="button" className="zq-btn zq-btn--solid zq-btn--lg" onClick={open}>
            Connect Wallet
          </button>
          <button type="button" className="zq-btn zq-btn--outline zq-btn--lg" onClick={open}>
            Claim
          </button>
        </div>
      </div>

      <div className="hero__banner">
        <img
          src={`${process.env.PUBLIC_URL}/images/hero-banner.webp`}
          alt=""
          role="presentation"
        />
      </div>
    </section>
  );
}